import { SxProps, Theme } from '@mui/material';

const layout: SxProps<Theme> = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  flexGrow: 1,
  mt: '30px',
  gap: '24px'
};

const pane: SxProps<Theme> = {
  flex: 1,
  minWidth: '653px',
  display: 'flex',
  flexDirection: 'column',
  gap: '25px'
};

// Scoped to the drawer, so the shared MUI accordion theme keeps its look
// elsewhere. The review accordion draws its own warning lines instead of the
// grey one.
const rightColumn: SxProps<Theme> = {
  width: '320px',
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
  '& .MuiAccordion-root.MuiPaper-root': {
    borderRadius: 0,
    backgroundColor: 'customGrey.light'
  },
  '& :not([data-accordion-border="warning"]) > .MuiAccordion-root': {
    borderBottom: '1px solid',
    borderBottomColor: 'customGrey.medium'
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '58px',
    p: '16px'
  },
  // First of type, so a value on the right, such as the score, keeps its own
  // colour.
  '& .MuiAccordionSummary-content > .MuiTypography-root:first-of-type, & .MuiAccordionSummary-content > div > .MuiTypography-root:first-of-type':
    {
      color: 'primary.main',
      fontSize: '16px',
      lineHeight: '26px'
    }
};

const accordions: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px'
};

const stageBlock: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
};

const stageHeading: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px'
};

const stageLabel: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '25px',
  color: 'customGrey.dark'
};

const stageHint: SxProps<Theme> = {
  fontSize: '16px',
  lineHeight: '24px',
  color: 'customGrey.dark'
};

const stageSelect: SxProps<Theme> = {
  '& .MuiSelect-select': {
    py: '16px',
    pl: '20px'
  },
  '& .MuiSelect-select .MuiTypography-root': {
    fontSize: '14px',
    lineHeight: '20px',
    color: 'customGrey.dark'
  },
  '& .MuiSelect-icon': {
    fontSize: '20px',
    right: '20px'
  }
};

export const conversationMessagingDetailsSx = {
  layout,
  pane,
  rightColumn,
  accordions,
  stageBlock,
  stageHeading,
  stageLabel,
  stageHint,
  stageSelect
};
